// Video registry. Each entry is served at /video/:slug.
// To add a video: upload to Cloudinary, then add an entry with its public ID and version
// (both come from the delivery URL: .../upload/v<version>/<publicId>.mp4).
export const videos = [
  {
    slug: 'agentic-diligence-promo',
    publicId: 'deal-os-promo-video',
    version: '1793635157',
    eyebrow: 'DEAL OS™ · PRODUCT PROMO',
    title: 'Agentic Diligence - Promo',
    description:
      'The Sovereign AI Platform for strategy and high-stakes deals. See how Deal OS™ compresses multi-week diligence into days and underwrites with conviction across the full deal lifecycle.',
    tags: ['CDD', 'AI Diligence','IC Memo'],
  },
  {
    slug: 'agentic-diligence-product-demo',
    publicId: 'deal-os-product-demo',
    version: '1793635972',
    eyebrow: 'Deal OS™ · Product Demo',
    title: 'Agentic Diligence - Product Demo',
    description:
      'Turn multi-week diligence into days of decisive clarity. Observe how Frontiers multi-agent DAG reconciles raw VDR evidence with deterministic valuation math—with your deal team in the loop.',
    tags: ['Studio', 'Memo', 'Model', 'Chat'],
  },
];

export const getVideo = (slug) => videos.find((v) => v.slug === slug);
